import '../modal.css';
import {ModalProps} from "../ModalProps";
import React, {useState} from "react";
import axios from "axios";
import {toast} from 'react-toastify';


export const ReviewModal = (modal: ModalProps) => {

    const [file, setFile] = useState<File | null>(null);
    const [name, setName] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState<{ name?: string; text?: string; }>({});

    const senSuccessfullyReview = () => {
        toast.success('Отзыв успешно отправлен!', {position:'bottom-right'});
    }

    const errorSendReview = (error: string) => {
        toast.warn(error, {position:'bottom-right'});
    }

    const isValidate = () => {
        const err: {name?: string; text?: string;} = {};
        if (!name.trim()){
            err.name = 'Укажите имя';
        }
        if (!text.trim()){
            err.text = 'Введите текст отзыва';
        }

        setError(err);
        return Object.keys(err).length === 0;
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (isValidate()) {
            try {
                const review = new FormData();
                review.append('name', name);
                review.append('msg', text);
                if (file) {
                    review.append('file', file);
                }
                const response = await axios.postForm('https://wow-holiday-server-miha823.amvera.io/api/review', review);

                if (response.data.success){
                    console.log("Отзыв отправлен");
                    senSuccessfullyReview();
                    resetForm();
                }
            } catch (err){
                console.log(err);
                resetForm();
                errorSendReview("Ошибка сервера!!!");
            }
            modal.onClose();
        }
    }

    if (!modal.isOpen) return null;

    const resetForm = () =>{
        setFile(null);
        setName('');
        setText('');
    }

    return (
        <div className="modal-overlay">
            <div className="modal-order">
                <button className="modal-close-button"
                        onClick={modal.onClose}
                        aria-label="Закрыть окно">
                </button>

                <h2 className={'modal__title modal-review__title'}>«ВАУ-моменты: расскажи о своём дне!» </h2>
                <a className={'contact-phone'} aria-label={'Номер'}  href="tel:+79642936313">+7(963) 293-63-13</a>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name"></label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            placeholder={'Имя'}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                        {error.name && <span className="error">{error.name}</span>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="review-text"></label>
                        <textarea
                            className={'review-msg'}
                            id="review-text"
                            placeholder={'Введите текст'}
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            required
                        />
                        {error.text && <span className="error">{error.text}</span>}
                    </div>
                    <div className="form-group file-form-group">
                        <label htmlFor="file" className={'label-input-file'}>Выбрать фотографию</label>
                        <input type="file" className={'input-file'} id="file" onChange={(e) => {
                            setFile(e.target.files?.[0] || null);
                        }}/><span>{file?.name}</span>
                    </div>

                    <button type="submit" className={'btn-sand'}>Отправить</button>

                </form>
            </div>
        </div>
    )
}